/** Driver hujjatlari (docs/13-hujjatlar.md). Backend: apps/documents. */
import type { UserRef } from "@/features/drivers/types";

export type DocumentStatus = "missing" | "requested" | "received" | "expiring" | "expired";
export type OcrStatus = "off" | "pending" | "done" | "failed";

/** Sozlamadagi tur (Settings -> Hujjatlar); `other` ro'yxatda yo'q, nomi qo'lda */
export interface DocumentType {
  key: string;
  label: string;
  required: boolean;
  expires: boolean;
}

export const OTHER_KIND = "other";

/** Rasmdagi matn qatori va joyi: [ymin, xmin, ymax, xmax], 0-1000 shkala (preview'da bosib nusxalash) */
export interface OcrLine {
  text: string;
  box: [number, number, number, number];
}

export interface DocumentOcr {
  /** Hujjatdan o'qilgan maydonlar (hujjat nomlari bilan: expires_at, cdl_number ...) */
  fields?: Record<string, unknown>;
  /** Faqat rasm uchun; PDF'da bo'sh (matn brauzer ko'ruvchisida tanlanadi) */
  lines?: OcrLine[];
  /** Driver maydonlari nomi bilan taklif (cdl_expires, medical_card_expires ...) -- apply shuni qabul qiladi */
  suggestions?: Record<string, unknown>;
  confidence?: Record<string, number>;
  warnings?: string[];
  detected_kind?: string;
  kind_mismatch?: boolean;
  name_mismatch?: boolean;
  model?: string;
  usage?: { input_tokens?: number; output_tokens?: number; thoughts_tokens?: number };
  at?: string;
  error?: string;
}

export interface OcrStatusInfo {
  configured: boolean;
  /** vertex -- Vertex AI + ADC (loyiha), api_key -- AI Studio kaliti, null -- sozlanmagan */
  auth: "vertex" | "api_key" | null;
  project: string;
  model: string;
  enabled: boolean;
  kinds: string[];
  known_price: boolean;
  month: { documents: number; failed: number; input_tokens: number; output_tokens: number; cost_usd: number | null };
}

export interface DriverDocument {
  id: number;
  driver: number;
  kind: string;
  title: string;
  label: string;
  status: DocumentStatus;
  /** Tur holati shu nusxadan hisoblanadi (bir turdan bir nechta nusxa bo'lganda); "other" va eski versiyalarda false */
  is_current: boolean;
  has_file: boolean;
  original_name: string;
  content_type: string;
  size: number;
  pages: number;
  issued_at: string | null;
  expires_at: string | null;
  /** CDL shtati (2 harf): boshqa shtatdagi yoki yangilangan CDL nusxalarini ajratadi */
  state: string;
  requested_at: string | null;
  requested_by: UserRef | null;
  uploaded_by: UserRef | null;
  created_at: string;
  ocr_status: OcrStatus;
  /** Faqat faylni ocha oladiganlarga keladi (sezgir) */
  ocr: DocumentOcr | null;
  ocr_reviewed_at: string | null;
  ocr_reviewed_by: UserRef | null;
  replaced_by: number | null;
  is_archived: boolean;
  archived_at: string | null;
  version: number;
  file_url: string | null;
  can_open: boolean;
}

export interface DocumentsSummary {
  received: number;
  total: number;
  required: number;
  missing: string[];
  requested: string[];
  expired: string[];
  expiring: string[];
  statuses: Record<string, DocumentStatus>;
}

export interface DocumentsResponse {
  documents: DriverDocument[];
  summary: DocumentsSummary;
  types: DocumentType[];
  can_open: boolean;
  versions?: DriverDocument[];
}

export interface DocumentMutationResponse {
  summary: DocumentsSummary;
  document?: DriverDocument;
}
